import type { EngineExports } from '@observant/shared';
import { instantiateEngine, type EngineImports } from './instantiate.js';

export type { EngineImports } from './instantiate.js';
export { f32View, u32View } from './memory.js';

/**
 * A loaded Observant engine: the typed wasm exports plus the raw instance
 * (for reaching linear memory in later milestones).
 */
export interface Engine {
  readonly exports: EngineExports;
  readonly instance: WebAssembly.Instance;
  /** The engine's exported linear memory, if present. */
  readonly memory: WebAssembly.Memory | undefined;
}

/**
 * Load and initialise the Observant engine from a wasm URL.
 *
 * @param wasmUrl  URL the runtime can `fetch` (e.g. `/game/engine.wasm`).
 * @param imports  Host imports for the module (none required in M1).
 */
export async function createEngine(wasmUrl: string, imports: EngineImports = {}): Promise<Engine> {
  const { exports, instance } = await instantiateEngine(wasmUrl, imports);
  const memory = instance.exports.memory;
  return {
    exports,
    instance,
    memory: memory instanceof WebAssembly.Memory ? memory : undefined,
  };
}
